import styles from './BurgerMenuButton.module.sass'
import cn from "classnames";
import {useEffect, useRef} from "react";
import {useGSAP} from "@gsap/react";
import gsap from "gsap";

const BurgerMenuButton = ({className, isMenuOpen, setIsMenuOpen, ...props}) => {

	// Timeline
	const burgerAnimationTimelineRef = useRef()

	// Lines Refs
	const upperLineRef = useRef()
	const upperShadowRef = useRef()
	const middleLineRef = useRef()
	const middleShadowRef = useRef()
	const bottomLineRef = useRef()
	const bottomShadowRef = useRef()

	useGSAP(() => {
		burgerAnimationTimelineRef.current = gsap.timeline({paused: true})
			.addLabel('burger_close')
			// 	Upper part Line
			.to(upperLineRef.current.attributes.x1, {value: 4}, 'burger_close')
			.to(upperLineRef.current.attributes.y1, {value: 28}, 'burger_close')
			.to(upperLineRef.current.attributes.x2, {value: 28}, 'burger_close')
			.to(upperLineRef.current.attributes.y2, {value: 4}, 'burger_close')

			.to(upperShadowRef.current.attributes.x1, {value: 4}, 'burger_close')
			.to(upperShadowRef.current.attributes.y1, {value: 28}, 'burger_close')
			.to(upperShadowRef.current.attributes.x2, {value: 28}, 'burger_close')
			.to(upperShadowRef.current.attributes.y2, {value: 4}, 'burger_close')
			.to(upperShadowRef.current, {opacity: 0}, 'burger_close')

			// 	Middle part Line
			.to(middleLineRef.current.attributes.x1, {value: 16,}, 'burger_close')
			.to(middleLineRef.current.attributes.x2, {value: 16}, 'burger_close')
			.to(middleShadowRef.current.attributes.x1, {value: 16}, 'burger_close')
			.to(middleShadowRef.current.attributes.x2, {value: 16}, 'burger_close')
			.to(middleShadowRef.current, {opacity: 0}, 'burger_close')

			// Bottom Line
			.to(bottomLineRef.current.attributes.x1, {value: 4}, 'burger_close')
			.to(bottomLineRef.current.attributes.y1, {value: 4}, 'burger_close')
			.to(bottomLineRef.current.attributes.x2, {value: 28}, 'burger_close')
			.to(bottomLineRef.current.attributes.y2, {value: 28}, 'burger_close')

			.to(bottomShadowRef.current.attributes.x1, {value: 4}, 'burger_close')
			.to(bottomShadowRef.current.attributes.y1, {value: 4}, 'burger_close')
			.to(bottomShadowRef.current.attributes.x2, {value: 28}, 'burger_close')
			.to(bottomShadowRef.current.attributes.y2, {value: 28}, 'burger_close')
			.to(bottomShadowRef.current, {opacity: 0}, 'burger_close')
			.addLabel('close_shown')
	}, [])


	useEffect(() => {
		burgerAnimationTimelineRef.current.tweenTo(isMenuOpen ? 'close_shown' : 'burger_close', {duration: 0.3})
	}, [isMenuOpen]);

	return (
			<div className={cn(styles.burger_btn, className, 'custom_pointer', 'burger_btn')}
			     onClick={() => {
				     setIsMenuOpen(!isMenuOpen)
			     }}
			     {...props}>
				<svg className={styles.burger_svg}
				     width="32"
				     height="32"
				     viewBox="0 0 32 32"
				     fill="none"
				     xmlns="http://www.w3.org/2000/svg">
					{/*Middle*/}
					<line ref={middleShadowRef} x1="0" y1="18" x2="32" y2="18" stroke="#408049" strokeWidth='2'></line>
					<line ref={middleLineRef} x1="0" y1="15" x2="32" y2="15" stroke="#EBFD6B" strokeWidth='4'></line>

					{/*Top*/}
					<line ref={upperShadowRef} x1="0" y1="5" x2="32" y2="5" stroke="#408049" strokeWidth='2'></line>
					<line ref={upperLineRef} x1="0" y1="2" x2="32" y2="2" stroke="#EBFD6B" strokeWidth='4'></line>

					{/*Bottom*/}
					<line ref={bottomShadowRef} x1="0" y1="31" x2="32" y2="31" stroke="#408049" strokeWidth='2'></line>
					<line ref={bottomLineRef} x1="0" y1="28" x2="32" y2="28" stroke="#EBFD6B" strokeWidth='4'></line>
				</svg>
			</div>
	)
}
export default BurgerMenuButton;